<div class="container mt-3 fade-in-left">
  <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>
    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Mi Obra Social / Prepaga</h1>
    </div>
  </div>

  <div class="row-cols-12 m-2 mt-0">
    <div class="row p-3 mb-0 align-items-center">
      <div class="mb-3 mt-0 text-start form-group">

        <!-- buscador -->
        <div class="row-cols-12 p-2 ps-0 pe-0 input-group fade-in search-input-row">
          <div class="rounded-start" id="search-addon">
            <div class="mx-auto d-block p-1 d-inline-flex pt-1 ps-2">
              <i class="bi bi-search"></i>
            </div>
          </div>

          <div class="col-10 rounded">
            <input
              type="search"
              class="form-control search-input shadow-none"
              placeholder="Buscar por nombre"
              aria-label="Search"
              aria-describedby="search-addon"
              [value]="searchDraft()"
              (input)="onSearchInput($any($event.target).value)"
            />
          </div>

          <div class="col rounded-end text-end" id="mic-addon">
            <div class="mx-auto d-block p-1 d-inline-flex">
              <i class="bi bi-mic"></i>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col obraslistadas">
            <label class="form-label">Obra Social / Prepaga</label>

            @if (error()) {
              <div class="alert alert-danger mt-2" role="alert">
                <small>{{ error() }}</small>
              </div>
            }

            @if (obrasFiltradas().length === 0) {
              <div class="alert alert-light border mt-2" role="alert">
                <small>No se encontraron resultados.</small>
              </div>
            } @else {
              @for (obraSocial of obrasFiltradas(); track obraSocial.id) {
                <div
                  class="row col-12 file btn btn-lg btn-primary fileupload m-1 btn btn-light border-radius"
                  (click)="selectObraSocial(obraSocial)"
                  [class.active]="isActiveObraSocial(obraSocial.id!)"
                >
                  {{ obraSocial.x_descripcion }}
                </div>
              }
            }
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
